"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.msoWarning = containerDimensions => {
    const containerHasPxHeight = containerDimensions.heightFormat === 'px' && !!containerDimensions.heightValue;
    const containerHasPxWidth = containerDimensions.widthFormat === 'px' && !!containerDimensions.widthValue;
    return !containerHasPxHeight || !containerHasPxWidth;
};
//# sourceMappingURL=calculate-warnings.js.map